import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { GroupRow } from '../components/GroupRow';
import { EmptyState, ErrorState, PageHeader, PageSkeleton } from '../components/ui';
import { errorMessage } from '../lib/format';
import { useGroups } from '../lib/queries';

/** Group list. With `pickForExpense`, choosing a group goes straight to "Add expense". */
export function GroupsPage({ pickForExpense = false }: { pickForExpense?: boolean }) {
  const { t } = useTranslation();
  const { data: groups, isPending, error, refetch } = useGroups();

  if (isPending) return <PageSkeleton />;
  if (error) return <ErrorState message={errorMessage(error, t)} onRetry={() => void refetch()} />;

  return (
    <main className={`page app ${pickForExpense ? 'page--no-tabbar' : ''}`}>
      <PageHeader
        title={pickForExpense ? t('quickAdd.title') : t('groups.title')}
        action={
          <Link className="btn btn--soft btn--small" to="/groups/new">
            + {t('dashboard.newGroup')}
          </Link>
        }
      />
      {groups.length === 0 ? (
        <div className="card">
          <EmptyState
            icon="groups"
            title={t('dashboard.emptyTitle')}
            body={t('dashboard.emptyBody')}
            action={
              <Link className="btn btn--primary" to="/groups/new">
                {t('groups.create')}
              </Link>
            }
          />
        </div>
      ) : (
        <div className="card card--flush list">
          {groups.map((g) => (
            <GroupRow key={g.id} group={g} to={pickForExpense ? `/groups/${g.id}/expenses/new` : undefined} />
          ))}
        </div>
      )}
    </main>
  );
}
